import { useHistory } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { Button } from 'components/DesignSystem/Button';
import classes from 'components/Settings/Components/RolesManagement/components/addRole.module.scss';
import { settingsConfig } from 'components/Settings/settingsConfig';

type IRoleButtons = {
    isLoadingCreateRole: boolean;
    isLoadingUpdateRole: boolean;
};

export const Buttons = ({ isLoadingCreateRole, isLoadingUpdateRole }: IRoleButtons) => {
    const isLoading = isLoadingCreateRole || isLoadingUpdateRole;
    const history = useHistory();

    const handleReset = (): void => {
        history.push(AppRoutes.buildPath(AppRoutes.SETTINGS, settingsConfig.roleManagement.link));
    };

    return (
        <div className={classes.buttonsContainer}>
            <Button
                size={'large'}
                variant={'primary'}
                type={'submit'}
                id={'newRoleButtonSave'}
                isLoading={isLoading}
                disabled={isLoading}
            >
                Save
            </Button>

            <Button size={'large'} variant={'secondary'} id={'newRoleButtonCancel'} onClick={() => handleReset()}>
                Cancel
            </Button>
        </div>
    );
};
